import { PrivilegeEnum } from '../lib/heyapi.gen';
import { IWhoami } from '../lib/types';

export const defaultUser: IWhoami = {
	userId: '54aac555-9f20-47ed-b7bb-f42d6f1f8de8',
	email: 'new15@trash-mail.com',
	name: 'User, New',
	firstName: 'New',
	lastName: 'User',
	phone: '12345667890',
	dateOfBirth: '1997-12-12',
	address: {
		streetNumber: '1',
		street: 'test',
		zipCode: '1234',
		city: 'test',
		country: undefined,
	},
	alternateInvoiceAddress: undefined,
	privileges: [
		PrivilegeEnum.CAN_CREATE_NEW_PAYMENT_INTENT_SETUP,
		PrivilegeEnum.CAN_MAKE_BOOKING,
		PrivilegeEnum.CAN_READ_BOOKINGS_OWN,
		PrivilegeEnum.CAN_CANCEL_BOOKING_OWN,
		PrivilegeEnum.CAN_ADD_PASSENGER_DETAILS,
		PrivilegeEnum.CAN_VERIFY_EMAIL_OWN,
		PrivilegeEnum.CAN_DELETE_ACCOUNT_OWN,
		PrivilegeEnum.CAN_ADD_FAVOURITE_ADDRESS,
		PrivilegeEnum.CAN_GET_ROUTE_PLAN,
		PrivilegeEnum.CAN_REDEEM_VOUCHER,
		PrivilegeEnum.CAN_GET_ALL_VOUCHERS,
		PrivilegeEnum.CAN_REMOVE_VOUCHERS,
		PrivilegeEnum.CAN_ADD_PUSH_TOKEN,
		PrivilegeEnum.CAN_TRIGGER_NOTIFICATION_MANUALLY,
		PrivilegeEnum.CAN_DO_PASSENGER_STUFF,
	],
	isBlacklisted: false,
	isDisabled: false,
	pleaseComplete: false,
	isStripeCustomerConnected: true,
	hasDefaultStripePaymentMethod: true,
	isInMoplaArea: false,
	metaData: {
		jobticketLastName: '15',
		jobticketFirstName: '15',
		awaitingJobTicketEmployeeDeletion: true,
	} as any,
	isEligibleForJobticket: true,
	disabilityStatusValidTo: undefined,
	language: 'en',
};
